module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzNGNTFCNSIgZD0iTTQzIDM5VjI0aC00djE1YzAgNSA0IDkgOSA5di00Yy0yLjggMC01LTIuMi01LTV6Ii8+PGNpcmNsZSBmaWxsPSIjOTBBNEFFIiBjeD0iMjQiIGN5PSIyNCIgcj0iMTkiLz48Y2lyY2xlIGZpbGw9IiMzNzQ3NEYiIGN4PSIyNCIgY3k9IjI0IiByPSIyIi8+PGcgZmlsbD0iIzI1MzI3OCI+PGNpcmNsZSBjeD0iMjQiIGN5PSIxNCIgcj0iNSIvPjxjaXJjbGUgY3g9IjI0IiBjeT0iMzQiIHI9IjUiLz48Y2lyY2xlIGN4PSIzNCIgY3k9IjI0IiByPSI1Ii8+PGNpcmNsZSBjeD0iMTQiIGN5PSIyNCIgcj0iNSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/film_reel.svg
// module id = 4177
// module chunks = 0